import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Invoice } from '../../models/domain/invoice';
import { SelectItem } from 'primeng/primeng';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { BaseResponse, IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { CreditCardArray } from '../../models/domain/credit.card';
import { InvoicePaymentRequest } from '../../models/ss-api/requests/invoice.payment.request';
import { Router } from '@angular/router';

export interface IMakePaymentDialogModel {
    title: string;
    subTitle: string;
    message: string;
    invoiceItem: Invoice;
    creditAmount: number;
}


@Component({
    selector: 'make-payment-dialog',
    styleUrls: ['./make.payment.dialog.css'],
    templateUrl: './make.payment.dialog.html'
})
export class MakePaymentDialog extends DialogComponent<IMakePaymentDialogModel, boolean> implements IMakePaymentDialogModel, OnInit {

    title: string;
    subTitle: string;
    message: string;
    invoiceItem: Invoice;
    creditAmount: number;

    IsBusy: boolean = false;

    private Data: CreditCardArray;

    creditCards: SelectItem[] = [];
    selectedCreditCard: SelectItem;

    selectedCreditCardID: number;

    successTitle: string = 'Success!';
    successMessage: string = 'Payment was processed.'

    errorTitle: string = 'Error!';
    errorMessage: string = 'Payment failed.'

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.setUpCreditCards();
    }

    async setUpCreditCards() {

        this.IsBusy = true;

        await this.api.getUsableCCards(this.invoiceItem.MemberID).subscribe(
            (result: BaseResponse<CreditCardArray>) => {
                this.Data = result.Data;

                // Sort the cards so default is always the first option
                let sortedCreditCards = this.Data.sort(function (a, b) {
                    return (a.IsDefault === b.IsDefault) ? 0 : a.IsDefault ? -1 : 1;
                })

                sortedCreditCards.forEach(e => {

                    if (!e.IsActive || e.IsDeleted || (!e.IsDefault && e.Status == 'Expired'))
                        return;

                    let newCard: SelectItem = {
                        label: e.FirstName + ' ' + e.LastName + ' - XXXX XXXX XXXX ' + e.LastFour, value: e.ID
                    };
                    this.creditCards.push(newCard);
                });

                this.selectedCreditCard = this.creditCards[0];
                this.selectedCreditCardID = this.creditCards[0].value;

                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );



    }

    CreditCardChanged(item: SelectItem) {
        this.selectedCreditCardID = item.value;
    }

    async confirm() {
        this.IsBusy = true;

        await this.TryMakePaymentAlert()
            .then((response: IBaseResponse<string>) => {

                // init dialog vars
                let cType = 'success';
                let cTitle = this.successTitle;
                let cMessage = this.successMessage;

                if (!response.Result) {
                    // not ok
                    cType = 'error';
                    cTitle = this.errorTitle;
                    cMessage = this.errorMessage;
                }

                // show result
                this.sweetAlertService.swal(
                    {
                        title: cTitle,
                        text: cMessage,
                        type: cType,
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                    }, (dismiss) => {
                    }); // keep this line to prevent promise error;
                this.closeOK();

            },
                (dismiss) => {
                    this.IsBusy = false;
                    return;
                });


    }

    TryMakePaymentAlert(): Promise<any> {
        // confirm
        return this.sweetAlertService.swal({
            title: 'You Sure?',
            text: 'Because you better be',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Sure as Heckfire!',
            cancelButtonText: 'No, sorry...',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {

                // return server request promise
                let request = new InvoicePaymentRequest();
                request.CreditCardID = this.selectedCreditCardID;
                request.InvoiceID = this.invoiceItem.InvoiceID;

                return this.api.TryInvoicePayment(request).toPromise();

            }
        })
    }

    GetCredits() {
        let credit = 0;

        if (this.creditAmount >= this.invoiceItem.Total) {
            credit = this.invoiceItem.Total;
        } else {
            credit = this.creditAmount;
        }

        return credit;
    }

    GetTotal() {
        let total = this.invoiceItem.Total - this.creditAmount;

        if (total < 0) {
            total = 0;
        }

        return total;
    }

    closeOK() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

}
